// The glass appearance's tint, glow and blur on this device, kept in
// localStorage beside `appearance` (per device, like the mode it refines).
import { create } from 'zustand'
import { DEFAULT_GLASS_LOOK, sanitizeGlassLook, type GlassLook } from '@/lib/glassLook'

const KEY = 'appearance-glass'

const read = (): GlassLook => {
  try {
    const v = localStorage.getItem(KEY)
    return v ? sanitizeGlassLook(JSON.parse(v)) : DEFAULT_GLASS_LOOK
  } catch {
    return DEFAULT_GLASS_LOOK
  }
}

export const useGlassLook = create<{ look: GlassLook; set: (look: Partial<GlassLook>) => void }>(
  (set, get) => ({
    look: read(),
    set: (patch) => {
      const look = sanitizeGlassLook({ ...get().look, ...patch })
      try {
        localStorage.setItem(KEY, JSON.stringify(look))
      } catch {
        /* private mode: this session only */
      }
      set({ look })
    },
  }),
)
